import getFetchOptions from '../utils/getFetchOptions';

import {ENDPOINT_URL} from '../constants/index';
import {apiErrorHandling} from '../utils/apiUtils';

export default function getUserInfo() {
	return fetch(
		`${ENDPOINT_URL}/adminuser/self`,
		getFetchOptions({
			method: 'GET',
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
